export default __webpack_public_path__ + "93caa86db31d3eee188c9a22c78bf96d.png";